import script from "./TestimonialsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TestimonialsSection.vue?vue&type=script&setup=true&lang=js"

import "./TestimonialsSection.vue?vue&type=style&index=0&id=6b2a483a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b2a483a"]])

export default __exports__